"use strict";

exports.__esModule = true;
exports.default = roundTo;
function roundTo(x) {
    var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var div = Math.pow(10, places);
    return Math.round(x * div) / div;
}


//////////////////
// WEBPACK FOOTER
// ./~/usfl/math/round-to.js
// module id = 93
// module chunks = 104101334113578 226573449209678